<!--
  One correction run. The header is the toggle; the closings live in the panel it controls. Same layout as the
  export run cards: the header stacks on a phone and sits on one row from `sm` up.
-->
<article class="rounded-2xl border border-gray-100 bg-white shadow-sm transition-all duration-200">
  <button type="button"
          class="flex w-full flex-col gap-2 rounded-2xl px-4 py-3 text-left transition-colors duration-200
                 hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
                 focus-visible:outline-theme-primary-500 sm:flex-row sm:items-center sm:justify-between"
          [attr.aria-expanded]="expanded()" [attr.aria-controls]="panelId()"
          (click)="toggled.emit(run().id)">
    <span class="min-w-0">
      <span class="block truncate text-sm font-bold tracking-tight text-gray-900">
        Übermittlung vom {{ run().createdUtc | date: 'dd.MM.yyyy, HH:mm' }} Uhr
      </span>
      <span class="block text-xs text-gray-500">{{ progressLabel() }}</span>
      @if (reasonText(); as text) {
        <!-- Clamped here, because the whole header is the toggle button; the panel below shows it in full. -->
        <span class="line-clamp-2 break-words text-xs text-gray-600">Grund: {{ text }}</span>
      }
    </span>

    <span class="flex shrink-0 items-center gap-2">
      @if (running()) {
        <span class="h-2 w-2 animate-pulse rounded-full bg-theme-primary-500" aria-hidden="true"></span>
      }
      <span class="rounded-full px-2.5 py-1 text-xs font-semibold"
            [class.bg-green-50]="run().state === 'completed'"
            [class.text-green-700]="run().state === 'completed'"
            [class.bg-theme-primary-50]="running()"
            [class.text-gray-600]="running()"
            [class.bg-amber-50]="run().state === 'completedWithErrors'"
            [class.text-amber-700]="run().state === 'completedWithErrors'"
            [class.bg-red-50]="run().state === 'failed'"
            [class.text-red-700]="run().state === 'failed'">{{ stateLabel() }}</span>
    </span>
  </button>

  @if (expanded()) {
    <div [id]="panelId()" class="border-t border-gray-100 px-4 py-3">
      @if (runError(); as message) {
        <p class="rounded-xl bg-red-50 px-3 py-2 text-sm text-red-700" role="alert">{{ message }}</p>
      }

      @if (reasonText(); as text) {
        <p class="mb-3 break-words text-sm text-gray-700" data-testid="correction-reason">
          <span class="font-semibold text-gray-900">Grund:</span> {{ text }}
        </p>
      }

      @if (items().length === 0 && !runError()) {
        <p class="text-sm text-gray-500">Die Kassenabschlüsse dieser Übermittlung werden geladen …</p>
      }

      <ul class="flex flex-col gap-2">
        @for (item of items(); track item.id) {
          <li class="flex flex-col gap-2 rounded-xl border border-gray-100 bg-gray-50/50 px-3 py-2.5
                     sm:flex-row sm:items-center sm:justify-between" data-testid="correction-item">
            <span class="min-w-0">
              <span class="flex flex-wrap items-center gap-2">
                <span class="truncate text-sm font-semibold text-gray-900">{{ label(item) }}</span>
                <span class="rounded-full px-2 py-0.5 text-xs font-semibold"
                      [class.bg-green-50]="tone(item) === 'success'"
                      [class.text-green-700]="tone(item) === 'success'"
                      [class.bg-gray-100]="tone(item) === 'running'"
                      [class.text-gray-600]="tone(item) === 'running'"
                      [class.bg-amber-50]="tone(item) === 'warning'"
                      [class.text-amber-700]="tone(item) === 'warning'"
                      [class.bg-red-50]="tone(item) === 'danger'"
                      [class.text-red-700]="tone(item) === 'danger'">{{ itemLabel(item) }}</span>
              </span>
              @if (reason(item); as message) {
                <span class="mt-1 block text-xs text-gray-600">{{ message }}</span>
              }
            </span>

            <!-- The server's own flag, rendered as it arrives: the rule lives in one place (#770 D3). -->
            @if (item.retryable) {
              <span class="flex shrink-0 items-center">
                <button type="button"
                        class="inline-flex items-center justify-center rounded-2xl border border-gray-200 px-4
                               py-2 text-sm font-semibold text-gray-600 shadow-sm transition-all duration-200
                               hover:border-gray-300 hover:bg-gray-50 active:scale-95
                               disabled:cursor-not-allowed disabled:opacity-30 disabled:grayscale"
                        [disabled]="retryingItemId() === item.id"
                        (click)="retry.emit(item)">
                  {{ retryingItemId() === item.id ? 'Wird erneut versucht …' : 'Erneut versuchen' }}
                </button>
              </span>
            }
          </li>
        }
      </ul>
    </div>
  }
</article>
